import { render } from "./PrivacyPolicyImprintLinks.vue?vue&type=template&id=c7a69056"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__